export function matchesUserSearch(user, searchText) {
  const email = typeof user?.email === "string" ? user.email : "";
  const search = typeof searchText === "string" ? searchText : "";
  return email.toLowerCase().includes(search.toLowerCase());
}
